import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { inject as service } from "@ember/service"

export default class UndoButton extends Component {
  @service("ember-store") store
  @service("undo") undoService

  isHovering = true

  mouseEnter() {
    set(this, "isHovering", true)
  }

  mouseLeave() {
    set(this, "isHovering", false)
  }

  @action
  undoIt() {
    get(this, "undoService").pop()
  }
}
